import React from "react";

const NeoList = (props) => {
  return (<ul className={`${props.extra ? props.extra : ""}`}>

    {props.children}
  </ul>);
};

export default NeoList;